/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MultiAccountOrganizationChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService#getOrganizationDetails
 */
export const GET_ORGANIZATION_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountOrganizationChirpService_getOrganizationDetails';
export const GET_ORGANIZATION_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ORGANIZATION_DETAILS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getOrganizationDetailsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService#updateOrgDataSharingConnections
 */
export const UPDATE_ORG_DATA_SHARING_CONNECTIONS_MUTATION_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountOrganizationChirpService_updateOrgDataSharingConnections';
export const UPDATE_ORG_DATA_SHARING_CONNECTIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_ORG_DATA_SHARING_CONNECTIONS_MUTATION_FIELD_NAME,
  args: ['dataSharingConnectionsAdded', 'dataSharingConnectionsRemoved', 'produceGimmiePortalHollow'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updateOrgDataSharingConnectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService#updateOrgCopyAssetConnections
 */
export const UPDATE_ORG_COPY_ASSET_CONNECTIONS_MUTATION_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountOrganizationChirpService_updateOrgCopyAssetConnections';
export const UPDATE_ORG_COPY_ASSET_CONNECTIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_ORG_COPY_ASSET_CONNECTIONS_MUTATION_FIELD_NAME,
  args: ['assetCopyingConnectionsAdded', 'assetCopyingConnectionsRemoved', 'produceGimmiePortalHollow'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.updateOrgCopyAssetConnectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService#updateReportingSharingConnections
 */
export const UPDATE_REPORTING_SHARING_CONNECTIONS_MUTATION_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountOrganizationChirpService_updateReportingSharingConnections';
export const UPDATE_REPORTING_SHARING_CONNECTIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_REPORTING_SHARING_CONNECTIONS_MUTATION_FIELD_NAME,
  args: ['connectionsToAdd', 'connectionsToRemove', 'produceGimmiePortalHollow'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.updateReportingSharingConnectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService#updateWorkflowConnections
 */
export const UPDATE_WORKFLOW_CONNECTIONS_MUTATION_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountOrganizationChirpService_updateWorkflowConnections';
export const UPDATE_WORKFLOW_CONNECTIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_WORKFLOW_CONNECTIONS_MUTATION_FIELD_NAME,
  args: ['connectionsToAdd', 'connectionsToRemove', 'produceGimmiePortalHollow'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.updateWorkflowConnectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.configuration.manager.rpc.MultiAccountOrganizationChirpService#getCurrentUserOrganizationAccess
 */
export const GET_CURRENT_USER_ORGANIZATION_ACCESS_QUERY_FIELD_NAME = 'com_hubspot_multi_account_configuration_manager_rpc_MultiAccountOrganizationChirpService_getCurrentUserOrganizationAccess';
export const GET_CURRENT_USER_ORGANIZATION_ACCESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CURRENT_USER_ORGANIZATION_ACCESS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getCurrentUserOrganizationAccessRpc, {
      timeout: ctx.timeout
    });
  }
});